export enum ReportSubject {
  Fruehdienst = "Frühdienst",
  Nachtdienst = "Nachtdienst",
  Spaetdienst = "Spätdienst",
  Verlaufsdokumentation = "Verlaufsdokumentation",
}
